// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__lsvcz","form":"styles_form__2owyE"};